import { render, staticRenderFns } from "./AdditionalOrders.vue?vue&type=template&id=716dd087&scoped=true&"
import script from "./AdditionalOrders.vue?vue&type=script&lang=js&"
export * from "./AdditionalOrders.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalOrders.vue?vue&type=style&index=0&id=716dd087&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716dd087",
  null
  
)

export default component.exports